import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router-dom';

import * as sagaAction from '../../sagas/saga_action';
import Layout from './layout';
import { clearToast } from '../../actions/views/toast';

export default withRouter(connect(state => ({
  toast: state.reducers.toast,
  playerSettings: state.reducers.player.settings,
}), dispatch => ({
  handleLogout: async () => {
    dispatch({
      type: sagaAction.SAGA_POST_LOGOUT,
    });
  },
  onToastClose: () => dispatch(clearToast()),
  handleProfile: async () => {
    dispatch({
      type: sagaAction.SAGA_GET_PLAYER_SETTINGS,
    });
    dispatch(push('/profile'));
  },
}))(Layout));
